import { classNames } from "primereact/utils";
import styles from "./EmojiIcon.module.scss";
import calendar from "./calendar.svg";
import departmentStore from "./departmentStore.svg";
import oneOClock from "./oneOClock.svg";
import redQuestionMark from "./redQuestionMark.svg";
import roundPushpin from "./roundPushpin.svg";
import sparkles from "./sparkles.svg";
import tearOffCalendar from "./tearOffCalendar.svg";
import womanRunning from "./womanRunning.svg";

// Our own SVG drawings of the emoji, made to look like Apple's, so every platform shows the
// same picture instead of whatever its own emoji font draws. Apple's emoji artwork itself is
// licensed only for display on Apple devices, so it cannot be shipped here. Loaded as <img>
// rather than inlined: each file then keeps its own gradient ids, which would otherwise
// collide between two emoji on the same page.
const emojiSources = {
  calendar,
  departmentStore,
  oneOClock,
  redQuestionMark,
  roundPushpin,
  sparkles,
  tearOffCalendar,
  womanRunning,
};

export type EmojiName = keyof typeof emojiSources;

interface IEmojiIconProps {
  name: EmojiName;
  className?: string;
}

export const EmojiIcon = ({ name, className }: IEmojiIconProps) => {
  return (
    <img
      className={classNames(styles.emoji, className)}
      src={emojiSources[name]}
      alt=""
      aria-hidden="true"
      draggable={false}
    />
  );
};
